// Safe wrapper for TikTok Pixel events.
// Silently no-ops if ttq isn't loaded (e.g. ad blocker or SSR).

export const tiktokTrack = (event, params = {}) => {
  try {
    if (typeof window !== "undefined" && window.ttq && typeof window.ttq.track === "function") {
      window.ttq.track(event, params);
    }
  } catch (_) {
    // ignore analytics errors
  }
};

export const tiktokIdentify = (data = {}) => {
  try {
    if (typeof window !== "undefined" && window.ttq && typeof window.ttq.identify === "function") {
      // TikTok hashes email/phone client-side (SHA-256) automatically.
      // Only send fields that are non-empty.
      const payload = {};
      if (data.email) payload.email = String(data.email).trim().toLowerCase();
      if (data.phone_number) payload.phone_number = String(data.phone_number).trim();
      if (data.external_id) payload.external_id = String(data.external_id).trim();
      if (Object.keys(payload).length > 0) {
        window.ttq.identify(payload);
      }
    }
  } catch (_) {
    // ignore
  }
};

export const tiktokPage = () => {
  try {
    if (typeof window !== "undefined" && window.ttq && typeof window.ttq.page === "function") {
      window.ttq.page();
    }
  } catch (_) {
    // ignore
  }
};
